/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/phone/QaPhoneItpList.tsx
 * FILE_ID: JOBHUB-QA-PHONE-ITP-001
 * PURPOSE: Phone ITP tab body. Reuses QaItpView. Does not mount QaItpModal.
 */
import { Loader2 } from 'lucide-react'
import type { QaAreaExecution } from '../../../qa/qaApi'
import { QaItpView } from '../QaItpView'
import type { QaItpRequest } from '../qaItpScope'
import type { JobQaTabController } from '../useJobQaTabController'
import { QA_PHONE_CONTROLS } from './qaPhoneControlInventory'

export function QaPhoneItpList({
  controller,
  request,
  areas,
  pending,
  showAll,
  onShowAll,
}: {
  controller: JobQaTabController
  request: QaItpRequest
  areas: QaAreaExecution[]
  pending: boolean
  showAll: boolean
  onShowAll: () => void
}) {
  const { api, props, selection, workspace } = controller
  if (pending) {
    return (
      <div className="flex items-center justify-center py-12 text-muted-foreground">
        <Loader2 className="mr-2 h-5 w-5 animate-spin" aria-hidden /> Loading ITP…
      </div>
    )
  }
  if (!workspace.activeInspectionId) {
    return <p className="p-4 text-sm text-muted-foreground">Create a QA list first.</p>
  }
  return (
    <div
      data-qa-phone-control={[
        QA_PHONE_CONTROLS.itpStatusButtons,
        QA_PHONE_CONTROLS.showAll,
        QA_PHONE_CONTROLS.editChecklist,
        QA_PHONE_CONTROLS.deleteChecklist,
        QA_PHONE_CONTROLS.pack,
      ].join(' ')}
    >
      <QaItpView
        areas={areas}
        checklistIds={request.checklistIds}
        itemIds={request.itemIds ? new Set(request.itemIds) : undefined}
        showAll={showAll}
        onShowAll={onShowAll}
        jobId={props.jobId}
        inspectionId={workspace.activeInspectionId}
        api={api}
        onMutated={workspace.invalidateExecution}
        onSetStatus={workspace.setItemStatus}
        statusPending={workspace.setStatus.isPending}
        itemSelection={{
          isSelected: (id, checklistId, areaId) => selection.isCheckIncluded(id, checklistId, areaId),
          onToggle: (id, checklistId, areaId) => selection.toggleCheck(id, checklistId, areaId),
        }}
        checklistSelection={{
          isSelected: (id) => selection.isSelected('checklists', id),
          onToggle: (id) => selection.toggle('checklists', id),
        }}
        onRenameChecklist={(checklistId, title) => {
          void api.renameChecklist(checklistId, title).then(workspace.invalidateExecution)
        }}
        onWriteError={controller.setError}
      />
    </div>
  )
}
